import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import { MicroAgent } from "@newrelic/browser-agent/loaders/micro-agent";
import { CONSENT_CHANGE_EVENT, hasAnalyticsConsent } from "./cookieConsent";

const BEACON = "bam.eu01.nr-data.net";

const browserAppConfig = (prefix) => {
  const values = {
    SECURITY: {
      applicationID: import.meta.env.VITE_NEW_RELIC_SECURITY_APPLICATION_ID,
      licenseKey: import.meta.env.VITE_NEW_RELIC_SECURITY_LICENSE_KEY,
      accountID: import.meta.env.VITE_NEW_RELIC_SECURITY_ACCOUNT_ID,
      agentID: import.meta.env.VITE_NEW_RELIC_SECURITY_AGENT_ID,
      trustKey: import.meta.env.VITE_NEW_RELIC_SECURITY_TRUST_KEY,
    },
    BROWSER: {
      applicationID: import.meta.env.VITE_NEW_RELIC_BROWSER_APPLICATION_ID,
      licenseKey: import.meta.env.VITE_NEW_RELIC_BROWSER_LICENSE_KEY,
      accountID: import.meta.env.VITE_NEW_RELIC_BROWSER_ACCOUNT_ID,
      agentID: import.meta.env.VITE_NEW_RELIC_BROWSER_AGENT_ID,
      trustKey: import.meta.env.VITE_NEW_RELIC_BROWSER_TRUST_KEY,
    },
  }[prefix];

  if (Object.values(values).some((value) => !value || value === "REPLACE_ME")) {
    return null;
  }

  const { applicationID, licenseKey, accountID, agentID, trustKey } = values;
  return {
    info: { applicationID, licenseKey, beacon: BEACON, errorBeacon: BEACON, sa: 1 },
    loader_config: { accountID, agentID, applicationID, licenseKey, trustKey },
  };
};

// A blocked URL can contain tokens, query strings or user data.
export const blockedOrigin = (blockedURI) => {
  if (blockedURI === "inline" || blockedURI === "eval") return blockedURI;
  try {
    const url = new URL(blockedURI);
    return url.protocol === "https:" || url.protocol === "http:"
      ? url.origin
      : "other";
  } catch {
    return "other";
  }
};

export const startNewRelicBrowser = () => {
  const securityConfig = browserAppConfig("SECURITY");
  const browserConfig = browserAppConfig("BROWSER");
  if (!securityConfig || !browserConfig) return;

  // MicroAgent only emits its mandatory PageView and explicitly recorded events.
  const securityAgent = new MicroAgent({
    ...securityConfig,
    exposed: false,
    init: {
      generic_events: { enabled: true, autoStart: true },
      jserrors: { enabled: false },
      logging: { enabled: false },
      metrics: { enabled: false },
      privacy: { cookies_enabled: false },
    },
  });

  window.addEventListener("securitypolicyviolation", (event) => {
    securityAgent.recordCustomEvent("KewordalCspViolation", {
      disposition: event.disposition,
      effectiveDirective: event.effectiveDirective,
      blockedOrigin: blockedOrigin(event.blockedURI),
    });
  });

  const browserAgent = new BrowserAgent({
    ...browserConfig,
    init: {
      ajax: { deny_list: [BEACON] },
      browser_consent_mode: { enabled: true },
      distributed_tracing: { enabled: true },
      performance: {
        capture_detail: false,
        capture_marks: false,
        capture_measures: true,
      },
      privacy: { cookies_enabled: true },
      session_replay: { enabled: true },
    },
  });

  const updateConsent = () => browserAgent.consent(hasAnalyticsConsent());
  window.addEventListener(CONSENT_CHANGE_EVENT, updateConsent);
  updateConsent();
};
